export default {
  'header:usp:free-shipping:EC': 'Versandkostenfreie Lieferung ab CHF 100',
};
